import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 * Returns `true` when the viewport is at least `bp` wide, using the value from
 * the Mantine theme breakpoints so screen-size logic has one source of truth.
 *
 * Resolves synchronously on first render (no flash) — this is a client-only SPA.
 * Use for conditional *rendering* (component swaps, master-detail, show/hide).
 * For pure layout reflow prefer CSS responsive props / `ResponsiveRow`.
 */
export function useBreakpointUp(bp: Breakpoint = 'sm'): boolean {
    const theme = useMantineTheme();
    return useMediaQuery(`(min-width: ${theme.breakpoints[bp]})`, true, { getInitialValueInEffect: false }) ?? true;
}
